/* unplugin-vue-components disabled */import script from "./SectionTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./SectionTitle.vue?vue&type=script&lang=ts&setup=true"

import "./SectionTitle.vue?vue&type=style&index=0&id=052fdc6a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-052fdc6a"]])

export default __exports__